import vue from 'vue'
import CourseSet from './CourseSet'
import CommonUpload from '../../common/Upload.vue'
import store from '@/store/index'
const CourseSetCreater = vue.extend(CourseSet)
let courseSetInstance

export default {
  open (courseDetail) {
    if (!courseSetInstance) {
      courseSetInstance = new CourseSetCreater({
        el: document.createElement('div'),
        store,
        components: {CommonUpload}
      })
      document.body.appendChild(courseSetInstance.$el)
    }
    courseSetInstance.courseDetail = courseDetail
    courseSetInstance.visible = true
  }
}
